<div class="col-10 col-md-7 col-xl-6 mx-auto mt-5 mb-3 stepper">
  <div class="d-flex stepper-line stepper-line-1">
      <ng-container *ngFor="let item of totalStep; let i = index; let last = last">
          <ng-container *ngIf = "currentStep <= i + 1">
              <div class="circle" [ngClass]="{
                  'circle-heather': currentStep < i + 1
              }"></div>
          </ng-container>
     
          <ng-container *ngIf = "currentStep > i + 1">
              <div class="circle circle-complete">
                  <img class="icon-info ml-auto" src="./assets/images/icon-png/tick.svg" alt="" />
              </div>
          </ng-container>
          <div class="line" [class.change-width]= "totalStep.length === 3" *ngIf="!last"></div>
      </ng-container>
  </div>
  <div class="row stepper-line">
      <ng-container *ngFor="let item of totalStep; let i = index">
          <span class="text" [ngClass]="{
              'text-heather': currentStep < i + 1
          }">{{item}}</span>
      </ng-container>
  </div>
</div>
<mat-horizontal-stepper [linear]="true" #stepper>
  <mat-step [stepControl]="firstFormGroup" [completed]="firstFormGroup.valid">
    <div class="manage-recipient"> 
      <div class="col-md-10 offset-md-1">
        <div class="receipient-header">
          <strong>Add new Approved Payer | </strong>Payer information
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-4 offset-md-4">
      <form [formGroup]="firstFormGroup">
        <ng-template matStepLabel>Step one</ng-template>
        <div class="row form-group">
          <mat-form-field [ngClass]="{
            'is-valid': firstFormGroup.get('legalName').valid && !firstFormGroup.hasError('pattern') && firstFormGroup.get('legalName').touched,
            'is-invalid': (!firstFormGroup.get('legalName').valid || firstFormGroup.hasError('pattern')) && firstFormGroup.get('legalName').touched
          }">
            <input matInput placeholder="Full legal name of Payer" formControlName="legalName" class="no-upscope"/>
          </mat-form-field>
          <div class="error-message" *ngIf="firstFormGroup.get('legalName').hasError('required') && firstFormGroup.get('legalName').touched">Name is required.</div>
          <div class="error-message" *ngIf="firstFormGroup.get('legalName').hasError('pattern')">
            Please include first and last names in the legal name.
          </div>
        </div>
        <div class="row form-group">
          <mat-form-field [ngClass]="{
                  'is-valid': firstFormGroup.get('payerType').valid && firstFormGroup.get('payerType').touched,
                  'is-invalid': !firstFormGroup.get('payerType').valid && firstFormGroup.get('payerType').touched
                }">
            <mat-select placeholder="Payer Type" formControlName="payerType">
              <mat-option *ngFor="let payerType of payerTypes" [value]="payerType.id">
                <span>{{payerType.name}}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="error-message" *ngIf="!firstFormGroup.get('payerType').valid && firstFormGroup.get('payerType').touched">
            Please input valid information here
          </div>
        </div>
        <ng-container>
          <div class="row form-group">
            <np-mat-autocomplete-hybrid 
              dataDisplayValue="name" [selectControl]="firstFormGroup.get('country')" 
              placeholder="Payer Country"
              [data]="countries" inputClass="capitalize-field"></np-mat-autocomplete-hybrid>
          </div>
        </ng-container>
        <ng-container>
          <div class="row form-group">
            <mat-form-field [ngClass]="{
              'btn-greengo': firstFormGroup.get('phone').touched,
              'btn-inactive': !firstFormGroup.get('phone').touched}">
              <input matInput placeholder="Phone" formControlName="phone" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="firstFormGroup.get('phone').hasError('pattern') && firstFormGroup.get('phone').touched">
              Must be valid phone number!
            </div>
          </div>
          <div class="row form-group">
            <mat-form-field [ngClass]="{
              'btn-greengo': firstFormGroup.get('address1').touched,
              'btn-inactive': !firstFormGroup.get('address1').touched}">
              <input matInput placeholder="Address 1" formControlName="address1" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="firstFormGroup.get('address1').hasError('pattern') && firstFormGroup.get('address1').touched">
                <np-swift-character-message></np-swift-character-message>
            </div>
            <div class="error-message" *ngIf="firstFormGroup.get('address1').hasError('maxlength') && firstFormGroup.get('address1').touched">
              Maximum of 35 characters
            </div>
          </div>
        </ng-container>
        <ng-container>
          <div class="row form-group">
            <mat-form-field [ngClass]="{
              'is-valid': firstFormGroup.get('address2').valid && firstFormGroup.get('address2').touched,
              'is-invalid': !firstFormGroup.get('address2').valid && !firstFormGroup.get('address2').touched}">
              <input matInput placeholder="Address 2" formControlName="address2" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="firstFormGroup.get('address2').hasError('pattern') && firstFormGroup.get('address2').touched">
              <np-swift-character-message></np-swift-character-message>
            </div>
            <div class="error-message" *ngIf="firstFormGroup.get('address2').hasError('maxlength') && firstFormGroup.get('address2').touched">
              Maximum of 35 characters
            </div>
          </div>
        </ng-container>
        <ng-container>
          <div class="row form-group">
            <mat-form-field [ngClass]="{
              'btn-greengo': firstFormGroup.get('city').touched,
              'btn-inactive': !firstFormGroup.get('city').touched}">
              <input matInput placeholder="Payer City" formControlName="city" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="firstFormGroup.get('city').hasError('pattern') && firstFormGroup.get('city').touched">
              <np-swift-character-message></np-swift-character-message>
            </div>
            <div class="error-message" *ngIf="firstFormGroup.get('city').hasError('maxlength') && firstFormGroup.get('city').touched">
              Maximum of 60 characters
            </div>
          </div>
        </ng-container>
        <ng-container>
          <div class="row form-group">
            <mat-form-field [ngClass]="{
              'btn-greengo': firstFormGroup.get('state').touched,
              'btn-inactive': !firstFormGroup.get('state').touched}">
              <input matInput placeholder="Payer State or Province" formControlName="state" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="firstFormGroup.get('state').hasError('pattern') && firstFormGroup.get('state').touched">
              <np-swift-character-message></np-swift-character-message>
            </div>
            <div class="error-message" *ngIf="firstFormGroup.get('state').hasError('maxlength') && firstFormGroup.get('state').touched">
              Maximum of 50 characters
            </div>
          </div>
        </ng-container>
        <ng-container>
          <div class="row form-group">
            <mat-form-field [ngClass]="{
              'btn-greengo': firstFormGroup.get('postCode').touched,
              'btn-inactive': !firstFormGroup.get('postCode').touched}">
              <input matInput placeholder="Payer Post Code" formControlName="postCode" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="firstFormGroup.get('postCode').hasError('pattern') && firstFormGroup.get('postCode').touched">
              <np-swift-character-message></np-swift-character-message>
            </div>
            <div class="error-message" *ngIf="firstFormGroup.get('postCode').hasError('maxlength') && firstFormGroup.get('postCode').touched">
              Maximum of 12 characters
            </div>
          </div>
        </ng-container>
        <ng-container>
          <div class="row form-group">
            <mat-form-field [ngClass]="{
              'btn-greengo': firstFormGroup.get('taxId').touched,
              'btn-inactive': !firstFormGroup.get('taxId').touched}">
              <input matInput placeholder="Payer Tax Id" formControlName="taxId" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="firstFormGroup.get('taxId').hasError('pattern') && firstFormGroup.get('taxId').touched">
              <np-swift-character-message></np-swift-character-message>
            </div>
          </div>
        </ng-container>
        <ng-container>
          <div class="row form-group">
            <np-mat-autocomplete-hybrid 
              dataDisplayValue="code" [selectControl]="firstFormGroup.get('currency')" 
              placeholder="Payer Currency"
              [data]="currencies" inputClass="capitalize-field"></np-mat-autocomplete-hybrid>
          </div>
        </ng-container>
        <ng-container>
          <div class="row form-group">
            Are you paying someone else? Would you like us to send them an email notification?
          </div>
          <div class="row my-4">
            <mat-radio-group formControlName="emailNotification">
              <mat-radio-button checked disableRipple [value]="true" (click)="focusYes()">Yes</mat-radio-button>
              <mat-radio-button disableRipple [value]="false" (click)="focusNo()">No</mat-radio-button>
            </mat-radio-group>
          </div>
  
          <div class="row form-group" *ngIf="showEmail">
            <mat-form-field [ngClass]="{
              'is-valid': firstFormGroup.get('email').valid && firstFormGroup.get('email').touched,
              'is-invalid': !firstFormGroup.get('email').valid && firstFormGroup.get('email').touched
            }">
              <input matInput formControlName="email" placeholder="Payer email" />
            </mat-form-field>
             <div class="error-message" *ngIf="firstFormGroup.get('email').hasError('required') && showEmail && firstFormGroup.get('email').touched">
              Please include payers email address
            </div>
          </div>
        </ng-container>
        <ng-container>
          <div class="row form-group">
            Is this a Payment Service Provider?
          </div>
          <div class="row my-4">
            <mat-radio-group formControlName="isPsp">
              <mat-radio-button checked disableRipple [value]="true" (click)="focusPspYes()">Yes</mat-radio-button>
              <mat-radio-button disableRipple [value]="false" (click)="focusPspNo()">No</mat-radio-button>
            </mat-radio-group>
          </div>
    
          <div class="row form-group" *ngIf="showPsp">
            <mat-form-field [ngClass]="{
                'is-valid': firstFormGroup.get('pspName').valid && firstFormGroup.get('pspName').touched,
                'is-invalid': !firstFormGroup.get('pspName').valid && firstFormGroup.get('pspName').touched
            }">
              <input matInput formControlName="pspName" placeholder="Payment Service Provider Name" />
            </mat-form-field>
            <div class="error-message" *ngIf="firstFormGroup.get('pspName').hasError('maxLength') && showPsp">
                Maximum of 35 characters
            </div>
            <div class="error-message" *ngIf="firstFormGroup.get('pspName').hasError('required') && showPsp && firstFormGroup.get('pspName').touched">
              Please include payment service provider name
            </div>
          </div>
        </ng-container>
        <div class="row form-group">
          <div class="col-6 pl-0">
            <button type="button" class="btn btn-lg btn-block btn-greengo-o" (click)="cancel()">
              Back
            </button>
          </div>
          <div class="col-6 pr-0">
            <button matStepperNext class="btn btn-lg btn-block btn-greengo" 
            [ngClass]="{'btn-greengo': firstFormGroup.valid,
            'btn-inactive': !firstFormGroup.valid}" (click)="loadBankingType()">Continue</button>
          </div>
        </div>
      </form>
    </div>
    
  </mat-step>
  <mat-step [stepControl]="secondFormGroup" [completed]="secondFormGroup.valid && bankDetailsFormGroup.valid">
    <ng-template matStepLabel>Step two</ng-template>
    <div class="col-md-10 offset-md-1">
      <div class="receipient-header">
        <strong >Payer Bank Account Details |</strong> Payment details
      </div>
    </div>
    <form [formGroup]="secondFormGroup" class="add-recipient">

      <div class="col-sm-12 col-md-4 offset-md-4">
        <ng-container *ngIf="isIBANRequired">
          <div class="row form-group">
            <mat-form-field [ngClass]="{
                  'is-valid': secondFormGroup.get('iban').valid && secondFormGroup.get('iban').touched,
                  'is-invalid': !secondFormGroup.get('iban').valid && secondFormGroup.get('iban').touched
                }">
              <input matInput placeholder="IBAN number" formControlName="iban" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="secondFormGroup.get('iban').hasError('required') && secondFormGroup.get('iban').touched">
              Please input information here
            </div>
            <div class="error-message" *ngIf="(
                  secondFormGroup.get('iban').hasError('maxlength') ||
                  secondFormGroup.get('iban').hasError('minlength') ||
                  secondFormGroup.get('iban').hasError('pattern')
                  ) && secondFormGroup.get('iban').touched">
              IBAN code must between 15 and 34 characters and must contains both letters and numbers or only contain letter.
            </div>
          </div>
        </ng-container>
  
        <ng-container *ngIf="isFasterPayandGBP">
          <div class="row form-group">
            <mat-form-field [ngClass]="{
                'is-valid': secondFormGroup.get('accountNumber').valid && !secondFormGroup.hasError('bankDetailsError') && secondFormGroup.get('accountNumber').touched,
                'is-invalid': (!secondFormGroup.get('accountNumber').valid && secondFormGroup.get('accountNumber').touched) ||
                 (!secondFormGroup.get('accountNumber').value && secondFormGroup.get('sortCode').value && !secondFormGroup.get('iban').value
                 && secondFormGroup.get('accountNumber').touched && secondFormGroup.get('sortCode').touched) ||
                 (secondFormGroup.hasError('bankDetailsError') && secondFormGroup.get('accountNumber').touched && secondFormGroup.get('sortCode').touched && secondFormGroup.get('iban').touched)
              }">
              <input matInput placeholder="Account number" formControlName="accountNumber" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="secondFormGroup.get('accountNumber').hasError('pattern') && secondFormGroup.get('accountNumber').touched">
              Account number must be 8 numbers.
            </div>
          </div>
  
          <div class="row form-group">
            <mat-form-field [ngClass]="{
                'is-valid': secondFormGroup.get('sortCode').valid && !secondFormGroup.hasError('bankDetailsError') && secondFormGroup.get('sortCode').touched,
                'is-invalid': (!secondFormGroup.get('sortCode').valid && secondFormGroup.get('sortCode').touched) ||
                 (!secondFormGroup.get('sortCode').value && secondFormGroup.get('accountNumber').value && !secondFormGroup.get('iban').value
                 && secondFormGroup.get('accountNumber').touched && secondFormGroup.get('sortCode').touched) ||
                 (secondFormGroup.hasError('bankDetailsError') && secondFormGroup.get('accountNumber').touched && secondFormGroup.get('sortCode').touched && secondFormGroup.get('iban').touched)
              }">
              <input matInput placeholder="Sort code" formControlName="sortCode" npInputMask [options]="{
                  delimiter: '-',
                  blocks: [2, 2, 2]
                }" (keypress)="$event.charCode >= 48 && $event.charCode <= 57" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="secondFormGroup.get('sortCode').hasError('pattern') && secondFormGroup.get('sortCode').touched">
              Sort code must be 6 characters and contain only numeric
            </div>
          </div>
  
          <div class="row form-group">
            or
          </div>
  
          <div class="row form-group">
            <mat-form-field [ngClass]="{
                          'is-valid': secondFormGroup.get('iban').valid && secondFormGroup.get('iban').touched,
                          'is-invalid': (!secondFormGroup.get('iban').valid || secondFormGroup.hasError('bankDetailsError')) && secondFormGroup.get('iban').touched
                        }">
              <input matInput placeholder="IBAN number" formControlName="iban" class="no-upscope" />
            </mat-form-field>
            <div class="error-message" *ngIf="(
                          secondFormGroup.get('iban').hasError('maxlength') ||
                          secondFormGroup.get('iban').hasError('minlength') ||
                          secondFormGroup.get('iban').hasError('pattern')
                          ) && secondFormGroup.get('iban').touched">
              IBAN code must between 15 and 34 characters and must contains both letters and numbers or only contain letter.
            </div>
            <div class="error-message" *ngIf="secondFormGroup.hasError('bankDetailsError')
                && secondFormGroup.get('sortCode').touched
                && secondFormGroup.get('accountNumber').touched
                && secondFormGroup.get('iban').touched">
              Please input Account Number and Sort Code or IBAN
            </div>
          </div>
        </ng-container>
  
        <ng-container *ngIf="isBankCodeAndAccountMandatory">
          <div class="row form-group">
            <mat-form-field [ngClass]="{
                    'is-valid': secondFormGroup.get('accountNumber').valid && secondFormGroup.get('accountNumber').value && secondFormGroup.get('accountNumber').touched,
                    'is-invalid': (!secondFormGroup.get('accountNumber').valid || !secondFormGroup.get('accountNumber').value) && secondFormGroup.get('accountNumber').touched
                  }">
              <input matInput placeholder="Account number" formControlName="accountNumber" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="!secondFormGroup.get('accountNumber').value && secondFormGroup.get('accountNumber').touched">
              Please input information here
            </div>
            <div class="error-message" *ngIf="secondFormGroup.get('accountNumber').hasError('pattern') && secondFormGroup.get('accountNumber').touched">
              <ng-container *ngIf="isFasterPay">
                Account number must be 8 numbers.
              </ng-container>
              <ng-container *ngIf="!isFasterPay">
                Account number is required and can only include characters and numbers.
              </ng-container>
            </div>
          </div>
  
          <div class="row form-group">
            <mat-form-field [ngClass]="{
                    'is-valid': secondFormGroup.get('bankCode').valid && secondFormGroup.get('bankCode').value && secondFormGroup.get('bankCode').touched,
                    'is-invalid': (!secondFormGroup.get('bankCode').valid || !secondFormGroup.get('bankCode').value) && secondFormGroup.get('bankCode').touched
                        }">
              <input matInput placeholder="Bank code" formControlName="bankCode" class="no-upscope"/>
            </mat-form-field>
            <div class="error-message" *ngIf="
                  !secondFormGroup.get('bankCode').value &&
                  secondFormGroup.get('bankCode').touched
                ">
              Please input information here
            </div>
  
            <div class="error-message" *ngIf="
                      secondFormGroup.get('bankCode').hasError('pattern') &&
                      !isBankCode9Digits &&
                      secondFormGroup.get('bankCode').touched
                    ">
              Bank code must be number and characters, no special characters
            </div>
            <div class="error-message" *ngIf="
                                secondFormGroup.get('bankCode').hasError('pattern') &&
                                isBankCode9Digits &&
                                secondFormGroup.get('bankCode').touched
                              ">
              Bank code must be 9 digits
            </div>
          </div>
        </ng-container>
  
  
        <ng-container *ngIf="!isFasterPayandGBP && !isIBANRequired && !isBankCodeAndAccountMandatory">
          <div class="row form-group">
            <mat-form-field [ngClass]="{
                            'is-valid': secondFormGroup.get('accountNumber').valid && secondFormGroup.get('accountNumber').value && secondFormGroup.get('accountNumber').touched,
                            'is-invalid': (!secondFormGroup.get('accountNumber').valid || !secondFormGroup.get('accountNumber').value) && secondFormGroup.get('accountNumber').touched
                          }">
              <input matInput placeholder="Account number" formControlName="accountNumber" class="no-upscope" />
            </mat-form-field>
            <div class="error-message" *ngIf="!secondFormGroup.get('accountNumber').value && secondFormGroup.get('accountNumber').touched">
              Please input information here
            </div>
            <div class="error-message"
              *ngIf="secondFormGroup.get('accountNumber').hasError('pattern') && secondFormGroup.get('accountNumber').touched">
              <ng-container *ngIf="isFasterPay">
                Account number must be 8 numbers.
              </ng-container>
              <ng-container *ngIf="!isFasterPay">
                Account number is required and can only include characters and numbers.
              </ng-container>
            </div>
          </div>
  
          <div class="row form-group justify-content-between align-items-center">
            <div class="col-5 px-0">
              <mat-form-field [ngClass]="{
                            'is-valid': secondFormGroup.get('bankCode').valid && (secondFormGroup.get('bankCode').value  || secondFormGroup.get('swiftCode').value) && secondFormGroup.get('bankCode').touched && secondFormGroup.get('swiftCode').touched,
                            'is-invalid': !secondFormGroup.get('bankCode').valid || (!secondFormGroup.get('bankCode').value && !secondFormGroup.get('swiftCode').value) && secondFormGroup.get('bankCode').touched && secondFormGroup.get('swiftCode').touched
                                }">
                <input matInput placeholder="Bank code" formControlName="bankCode" class="no-upscope" />
              </mat-form-field>
            </div>
            <div>or</div>
            <div class="col-5 px-0">
              <mat-form-field [ngClass]="{
                            'is-valid': secondFormGroup.get('swiftCode').valid && (secondFormGroup.get('bankCode').value  || secondFormGroup.get('swiftCode').value) && secondFormGroup.get('bankCode').touched && secondFormGroup.get('swiftCode').touched,
                            'is-invalid': !secondFormGroup.get('swiftCode').valid || secondFormGroup.hasError('swiftCodeError') || (!secondFormGroup.get('bankCode').value && !secondFormGroup.get('swiftCode').value) && secondFormGroup.get('bankCode').touched && secondFormGroup.get('swiftCode').touched
                                }">
                <input matInput placeholder="SWIFT code" formControlName="swiftCode" />
              </mat-form-field>
            </div>
            <div class="error-message"
              *ngIf="!secondFormGroup.get('swiftCode').value && secondFormGroup.get('swiftCode').touched && !secondFormGroup.get('bankCode').value && secondFormGroup.get('bankCode').touched">
              Please input bank code or SWIFT code
            </div>
            <div class="error-message" *ngIf="
                                                    (secondFormGroup.hasError('swiftCodeError') ||
                                                    secondFormGroup.get('swiftCode').hasError('pattern')) &&
                                                    secondFormGroup.get('swiftCode').touched
                                                  ">
              SWIFT code must be 8 or 11 letters. SWIFT code must contain both number and letter or only contain letter
            </div>
            <div class="error-message" *ngIf="
                              secondFormGroup.get('bankCode').hasError('pattern') &&
                              secondFormGroup.get('bankCode').touched
                            ">
              Bank code must be number and characters, no special characters
            </div>
          </div>
        </ng-container>
  
        <ng-container *ngIf= "!validationOk">
          <div class="row col-6 px-0">
            <button class="btn btn-lg btn-block" [ngClass]="{
              'btn-greengo': secondFormGroup.valid,
              'btn-inactive': !secondFormGroup.valid
            }" (click)="validateAndAutoFillBankDetails()" npFocusOutClicked>Continue</button>
          </div>
          <div class="row">
            <p class="mt-3">Once the information entered has been validated successfully, beneficiaries bank details will be automatically filled below.</p>
          </div>
        </ng-container>
      </div>
    </form>

    <form [formGroup]="bankDetailsFormGroup" class="add-recipient">

      <div class="col-md-10 offset-md-1">
        <div class="receipient-header">
          <strong>Payer Bank Details</strong>
        </div>
      </div>
  
      <div class="col-sm-12 col-md-4 offset-md-4">
        <div class="row form-group">
          <mat-form-field [ngClass]="{
            'is-valid': bankDetailsFormGroup.get('bankName').valid && bankDetailsFormGroup.get('bankName').touched,
            'is-invalid': !bankDetailsFormGroup.get('bankName').valid && bankDetailsFormGroup.get('bankName').touched
          }">
            <input matInput placeholder="Bank Name" formControlName="bankName" readonly>
          </mat-form-field>
          <div class="error-message" *ngIf="bankDetailsFormGroup.get('bankName').hasError('required') && bankDetailsFormGroup.get('bankName').touched">
            Please input information here
          </div>
          <div class="error-message" *ngIf="bankDetailsFormGroup.get('bankName').hasError('maxlength') && bankDetailsFormGroup.get('bankName').touched">
            Maximum of 100 characters
          </div>
        </div>
  
        <div class="row form-group">
          <mat-form-field [ngClass]="{
            'is-valid': bankDetailsFormGroup.get('address1').valid && bankDetailsFormGroup.get('address1').touched,
            'is-invalid': !bankDetailsFormGroup.get('address1').valid && bankDetailsFormGroup.get('address1').touched
          }">
            <input matInput placeholder="Address line 1" formControlName="address1" readonly>
          </mat-form-field>
          <div class="error-message" *ngIf="bankDetailsFormGroup.get('address1').hasError('required') && bankDetailsFormGroup.get('address1').touched">
            Please input information here
          </div>
          <div class="error-message" *ngIf="bankDetailsFormGroup.get('address1').hasError('maxlength') && bankDetailsFormGroup.get('address1').touched">
            Maximum of 255 characters
          </div>
        </div>
  
        <div class="row form-group">
          <mat-form-field [ngClass]="{
            'is-valid': bankDetailsFormGroup.get('address2').valid && bankDetailsFormGroup.get('address2').touched,
            'is-invalid': !bankDetailsFormGroup.get('address2').valid && bankDetailsFormGroup.get('address2').touched
          }">
            <input matInput placeholder="Address line 2" formControlName="address2" readonly>
          </mat-form-field>
          <div class="error-message" *ngIf="bankDetailsFormGroup.get('address2').hasError('maxlength') && bankDetailsFormGroup.get('address2').touched">
            Maximum of 255 characters
          </div>
        </div>
  
        <div class="row form-group">
          <mat-form-field [ngClass]="{
            'is-valid': bankDetailsFormGroup.get('address3').valid && bankDetailsFormGroup.get('address3').touched,
            'is-invalid': !bankDetailsFormGroup.get('address3').valid && bankDetailsFormGroup.get('address3').touched
          }">
            <input matInput placeholder="Address line 3" formControlName="address3" readonly>
          </mat-form-field>
          <div class="error-message" *ngIf="bankDetailsFormGroup.get('address3').hasError('maxlength') && bankDetailsFormGroup.get('address3').touched">
            Maximum of 255 characters
          </div>
        </div>
  
        <div class="row form-group">
          <mat-form-field [ngClass]="{
            'is-valid': bankDetailsFormGroup.get('city').valid && bankDetailsFormGroup.get('city').touched,
            'is-invalid': !bankDetailsFormGroup.get('city').valid && bankDetailsFormGroup.get('city').touched
          }">
            <input matInput placeholder="City" formControlName="city" readonly>
          </mat-form-field>
          <div class="error-message" *ngIf="bankDetailsFormGroup.get('city').hasError('required') && bankDetailsFormGroup.get('city').touched">
            Please input information here
          </div>
          <div class="error-message" *ngIf="bankDetailsFormGroup.get('city').hasError('maxlength') && bankDetailsFormGroup.get('city').touched">
            Maximum of 50 characters
          </div>
        </div>
  
        <div class="row form-group">
          <mat-form-field [ngClass]="{
            'is-valid': bankDetailsFormGroup.get('stateProvince').valid && bankDetailsFormGroup.get('stateProvince').touched,
            'is-invalid': !bankDetailsFormGroup.get('stateProvince').valid && bankDetailsFormGroup.get('stateProvince').touched
          }">
            <input matInput placeholder="State/Province" formControlName="stateProvince" readonly>
          </mat-form-field>
          <div class="error-message" *ngIf="bankDetailsFormGroup.get('stateProvince').hasError('maxlength') && bankDetailsFormGroup.get('stateProvince').touched">
            Maximum of 100 characters
          </div>
        </div>
  
        <div class="row form-group">
          <mat-form-field [ngClass]="{
            'is-valid': bankDetailsFormGroup.get('zipPostalCode').valid && bankDetailsFormGroup.get('zipPostalCode').touched,
            'is-invalid': !bankDetailsFormGroup.get('zipPostalCode').valid && bankDetailsFormGroup.get('zipPostalCode').touched
          }">
            <input matInput placeholder="Zip code/Postal code" formControlName="zipPostalCode" readonly>
          </mat-form-field>
          <div class="error-message" *ngIf="bankDetailsFormGroup.get('zipPostalCode').hasError('maxlength') && bankDetailsFormGroup.get('zipPostalCode').touched">
            Maximum of 20 characters
          </div>
        </div>
  
        <div class="row form-group">
          <mat-form-field>
            <mat-select placeholder="Country" formControlName="country" disabled>
              <mat-select-trigger>
                <ng-container *ngIf="!bankDetailsFormGroup.get('country').value; else showCountry">
                  -----
                </ng-container>
                <ng-template #showCountry>
                  <div [innerHTML]="bankDetailsFormGroup.get('country').value | transformCountry : countries"></div>
                </ng-template>
              </mat-select-trigger>
              <mat-option *ngFor="let country of countries" [value]="country.id">
                <span [class]="country.code | flagIcon"></span>&nbsp;
                <span>{{country.name}}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
  
        <div class="row form-group">
          <mat-form-field [ngClass]="{
            'is-valid': bankDetailsFormGroup.get('reference').valid && bankDetailsFormGroup.get('reference').touched,
            'is-invalid': !bankDetailsFormGroup.get('reference').valid && bankDetailsFormGroup.get('reference').touched
          }">
            <input matInput placeholder="Reference (Optional)" formControlName="reference" maxlength="70">
          </mat-form-field>
          <div class="error-message" *ngIf="bankDetailsFormGroup.get('reference').hasError('maxlength') && bankDetailsFormGroup.get('reference').touched">
            Maximum of 70 characters
          </div>
          <div class="error-message" *ngIf="bankDetailsFormGroup.get('reference').hasError('pattern') && bankDetailsFormGroup.get('reference').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>
  
        <div class="row form-group">
          <mat-form-field [ngClass]="{
            'is-valid': bankDetailsFormGroup.get('bankAccountType').valid && bankDetailsFormGroup.get('bankAccountType').touched,
            'is-invalid': !bankDetailsFormGroup.get('bankAccountType').valid && bankDetailsFormGroup.get('bankAccountType').touched
          }">
            <mat-select placeholder="Bank Account Type" formControlName="bankAccountType">
              <mat-option [value]="null">None</mat-option>
              <mat-option *ngFor="let item of bankAccountTypes" [value]="item.id">
                {{item.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="error-message"
            *ngIf="!bankDetailsFormGroup.get('bankAccountType').valid && bankDetailsFormGroup.get('bankAccountType').touched">
            Please input information here
          </div>
        </div>
  
        <div class="row mt-2">
          <div class="col-6 pl-0 form-group">
            <button matStepperPrevious type="button" class="btn btn-lg btn-block btn-greengo-o">Back</button>
          </div>
          <div class="col-6 pr-0 form-group">
            <button matStepperNext class="btn btn-lg btn-block" [ngClass]="{
                'btn-greengo': validationOk,
                'btn-inactive': !validationOk
              }" npFocusOutClicked (click)="bankDetailsFilled()">
              <ng-container>Next</ng-container>
            </button>
          </div>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step [completed]="false">
    <ng-template matStepLabel>Approval</ng-template>
    <div class="col-md-10 offset-md-1">
      <div class="receipient-header">
        <strong>Add new beneficiary |</strong> 2FA Security
      </div>
    </div>
    
    <np-pin-twillio-authy [buttonName]="btnName" [email]="registerService.email" (onetouchApproved)="onetouchApproved()"
      (submitted)="onSubmittedAuthy($event)" (sendCode)="sendPassCode($event)" [pinCodeError]="pinCodeError"
      [ticketType]="ticketType" (exceedInvalidCode)="exceedInvalidCode()" (validPin)="changeStatus($event)"
      [sendOnetouchSuccess]="sendOnetouchSuccess"></np-pin-twillio-authy>
  </mat-step>
</mat-horizontal-stepper>